import { Component, ViewChild } from '@angular/core';
import { DashboardService } from '../../../../../service/events/dashboard.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseForm } from '../../../../base-form';
import { VentasApiService } from '../../../../../service/api/ventas-api.service';
import { RequestButtonComponent } from 'src/app/common/components/request-button/request-button.component';
import { environment } from 'src/environments/environment';

import type { OnInit } from '@angular/core';
import { Compradores } from 'src/app/models/ventas/compradores.model';
import { CompradoresFormDefinition } from './form-definition';
import { EventPhase, FormPhase } from 'src/app/common/components/reactive-form-builder/form-request';
import { ReactiveFormRequestCoordinator } from 'src/app/common/components/reactive-form-builder/form-request-flow.coordinator';
import { ReactiveFormChangedField, ReactiveFormValue } from 'src/app/common/components/reactive-form-builder/interfaces/reactive-form-change.interface';

@Component({
    selector: 'app-compradores-form',
    standalone: false,
    templateUrl: './compradores-form.component.html',
    styleUrls: ['./compradores-form.component.scss']
})
export class CompradoresFormComponent extends BaseForm<Compradores> implements OnInit {

    @ViewChild(RequestButtonComponent, { read: RequestButtonComponent, static: true })
    requestButton = new RequestButtonComponent<Compradores>();

    public form!: CompradoresFormDefinition;

    public formRequest = new ReactiveFormRequestCoordinator<Compradores>;

    public override model: Compradores = {} as Compradores;


    constructor(public override dashboard: DashboardService,
        public override router: Router,
        public override route: ActivatedRoute,
        public ventasApi: VentasApiService
    ) {
        super(
            route,
            router,
            dashboard,
            ventasApi.compradoresPUT,
            ventasApi.compradoresPOST,
            'compradores',
            'Actualizar ' + environment.features.comercioName,
            'Crear ' + environment.features.comercioName
        );

                this.form = new CompradoresFormDefinition(
                    this.getType(),
                    this.getModel() as unknown as Record<string, string>,
                    null
                );
    }

    ngOnInit() {
        this.formRequest.addEvent(FormPhase.LOAD, EventPhase.AFTER, (resolve) => {
            this.form.lists.tipos.selected = 'Proveedor';
            this.form.model.tipo = 'Proveedor';
            resolve(true);
        });

        this.softInit(this.getType());
    }

    public formChanges(formModel: ReactiveFormValue<Compradores>, lastChangedFieldName: ReactiveFormChangedField<Compradores>): void {
        this.form.model = formModel;
        this.form.tag = lastChangedFieldName;
    }// ();
}// class;
